import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';

import DestinationCarousel from './destination';
import CoreCompetency from './coreCompetency';
import Discovery from './discovery';
import Hotels from '../../components/hotels/hotels-home';
import PartnersExclusive from './partnersExclusive';

import HomeMantle from './../../components/mantles/mantle';
import { GlobalTheme } from './../../theme';
import Testimonial from './../../components/testimonials/testimonials';
import { Helmet } from 'react-helmet-async';
import BgImg from './assets/images/bg.jpg';
import Members from './../../components/members/members';
import Counter from '../../components/counter/counter';
import FAQ from '../../components/faq/faq';
import SplCarousel from '../../pages/home/special_feature_corousel'
export default function Home() {
    const theme = useTheme();
    const [discoveryData, setDiscoveryData] = useState([]);
    useEffect(() => {
        fetch("https://aaryanholidays.in/frontend/discovery")
            .then(res => res.json())
            .then((result) => {
                const sortedData = result.sort((a, b) => {
                    const orderA = parseInt(a.appear_order, 10) || 0;
                    const orderB = parseInt(b.appear_order, 10) || 0;
                    return orderA - orderB;
                });
                setDiscoveryData(sortedData);
            })
            .catch(error => console.error("Error fetching discovery data:", error));
    }, []);
    return (
        <React.Fragment>
            <Helmet>
                <title>Welcome to Aaryan Leisures & Holidays</title>
                <meta name="description" content='Aaryan Leisure & Holidays Pvt Ltd is a tour and travel operator wih headquater in Kolkata, with sales offices in Punjab, Odisha and Maharashtra India, offering a range of travel-related services. It ia an IATA-approved travel company that has been operating since 2001, catering to both domestic and international travellers.' />
                <meta name="keywords" content="Aaryan Holidays, IATA approved travel agency, travel agency in Kolkata, travel agency in Odisha, travel agency in Punjab, travel agency in Maharashtra, holiday packages, Customized holiday packages, Domestic tour packages in India, International tour packages from India, flight bookings, hotel reservations, exotic destinations, Luxury international holidays, Europe tour packages from India" />
                <meta property="og:title" content="Welcome to Aaryan Leisures & Holidays" />
                {/* <meta property="og:description" content={tour?.banner_description || ""} />
                <meta property="og:url" content={`https://aaryanholidays.com/tour-details/4/${refer_other_id}`} />
                <meta property="og:image" content={`${BASE_MEDIA_URL}${tour?.banner_src}` || ""} /> */}


            </Helmet>
            <ThemeProvider theme={GlobalTheme}>
                <CssBaseline />
                <HomeMantle home={1} />

                <Grid component='section' aria-labelledby='destinationHeading'
                    sx={{
                        textAlign: 'center',
                        py: 7,
                        // backgroundImage: `url(${BgImg})`,
                        // backgroundAttachment: 'fixed',
                    }}>
                    <Container fixed disableGutters>
                        <DestinationCarousel />
                    </Container>
                </Grid>

                <Container maxWidth="xxl"
                    sx={{
                        [theme.breakpoints.down('sm')]: {
                            px: 0,
                        },
                        [theme.breakpoints.up('sm')]: {
                            px: 0,
                        }
                    }}>

                    <Grid component='section' aria-labelledby='vacationHeading' sx={{ textAlign: 'center', backgroundColor: GlobalTheme.palette.primary.main, color: GlobalTheme.palette.common.white }} >
                        {/* <Container sx={{ py: 7 }}>
                            <Typography variant="h2" component="h2" sx={{ color: GlobalTheme.palette.common.white, mb: 2 }} id="vacationHeading">
                                Make your vacation unforgettable<br />
                                with Aaryan leisure & holidays
                            </Typography>
                            <Typography variant='' component='p' sx={{
                                md: { px: 20 },
                                textWrap: 'balance', wordBreak: 'break-word'

                            }}>
                                Whether you're after a beach escape, mountain adventure, or cultural city tour, Aaryan Leisure & Holidays offers tailored travel packages for lasting memories.<br /><br />
                                Enjoy top-notch service, exclusive deals, and personalized itineraries for a perfect mix of comfort, excitement, and relaxation. Make your next vacation unforgettable!
                            </Typography>
                        </Container> */}

                        <Container maxWidth="false" disableGutters sx={{ backgroundColor: GlobalTheme.palette.warning.light }}>
                            <Discovery />
                        </Container>
                    </Grid>
                    {discoveryData.map(discovery => (
                        <Grid component='section' aria-labelledby={`destinationHeading${Date.now()}`}
                            sx={{
                                textAlign: 'center',
                                pt: 7,
                            }}>
                            <Container fixed disableGutters>
                                <SplCarousel discovery={discovery.discovery} />
                            </Container>
                        </Grid>
                    ))}



                    <Counter />

                    <Hotels />
                    {/* <Container maxWidth="lg" sx={{ pt: 6, pb: 3, textAlign: 'center', py: 5 }} aria-labelledby="popularHotelsHeading" component="section">
                        



                    </Container> */}



                    <Container fixed sx={{ pt: 6, pb: 3, textAlign: 'center', backgroundColor: GlobalTheme.palette.common.white }} aria-labelledby="competencyHeading" component="section">
                        <Typography id="competencyHeading" variant='h2' component='h2' sx={{ mb: 2 }}>Our Partners</Typography>
                        <Typography variant='subtitle2' component='p' sx={{ mb: 4 }}>Our true destination specialty! As authorized travel partners, we ensure your unforgettable journey to these places with unmatched expertise and personalized services. Let us take you to the destinations we know best!</Typography>

                        <CoreCompetency />
                    </Container>

                    <Container maxWidth="xxl" sx={{ pt: 6, pb: 3, backgroundColor: GlobalTheme.palette.common.grayLight }} aria-labelledby="membersHeading" component="section">
                        <Members />
                    </Container>

                    <Container maxWidth="xxl" sx={{ py: 6, backgroundColor: GlobalTheme.palette.warning.light }} aria-labelledby="testimonialHeading" component="section">
                        <Typography id="testimonialHeading" variant='h2' component='h2' sx={{ mb: 2, textAlign: 'center' }}>Appreciative feedback</Typography>
                        <Container>
                            <Testimonial />
                        </Container>
                    </Container>

                    <Container maxWidth="xxl" sx={{ pt: 6, pb: 3, textAlign: 'center', backgroundColor: GlobalTheme.palette.common.grayLight }} aria-labelledby="partnersHeading" component="section">
                        <Container fixed>
                            <Typography id="partnersHeading" variant='h2' component='h2' sx={{ mb: 2, textAlign: 'left' }}>partners exclusive insight</Typography>
                            <PartnersExclusive />
                        </Container>
                    </Container>

                    <Container maxWidth="lg" sx={{ py: 6 }} aria-labelledby="faqHeading" component="section">
                        <FAQ />
                    </Container>


                </Container>
            </ThemeProvider>
        </React.Fragment >
    )

}